module.exports = __webpack_public_path__ + "img/xmasParty17.2dff4022.jpg";